<template>
  <div class="footer">
    <!--<p @click="onClick('Mensch')" class="font-kristi about">Mensch</p>-->
    <p @click="onClick('Contact')" class="font-kristi about">Contact</p>
    <p @click="onClick('About')" class="font-kristi about">About</p>
    <a href="https://www.instagram.com/lokomotiveooo/" target="_blank" class="font-kristi about">Instagram</a>

  </div>
</template>

<script>
export default {
  name: 'Footer',

  methods: {
    onClick (routeName) {
      this.$router.push({
        name: routeName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px;
  //background-color: $c-red;
  background-image: url('../assets/img/footer-bg.png');
  background-size: 100%;
  z-index: 3;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  text-align: center;

  @include breakpoint('xs-only') {
    text-align: center;
    width: 100%;
  }

  a,
  p {
    color: $c-yellow;
    font-weight: bold;
    // color: $c-white;
    margin: 0 20px;
    font-size: 14px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    text-decoration: none;

    @include breakpoint('md-and-down') {
      font-size: 12px;
      margin: 0 10px;
    }

    @include breakpoint('xs-only') {
      font-size: 12px;
      margin: 0 7px;
    }

    &::after {
      display: none;
      content: ' ';
      width: 10px;
      height: 10px;
      border-radius: 10px;
      background-color: #fff;
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
